import React, { useState } from 'react';
import { useModal } from '../../hooks/useModal';

const Header: React.FC = () => {
  const { openUserTypeModal } = useModal();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header>
      <nav className="navbar navbar-expand-lg navbar-dark">
        <div className="container-fluid">
          <a className="navbar-brand" href="#">
            <img src="/assets/images/Red Combined 1 (1).png" alt="Whatsnxt Logo" />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleMenu}
            aria-controls="navbarNav"
            aria-expanded={isMenuOpen}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav mt-2 justify-content-center">
              <li className="nav-item">
                <a
                  className="nav-link active"
                  aria-current="page"
                  href="#home"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('home');
                    closeMenu();
                  }}
                >
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#benefits"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('benefits');
                    closeMenu();
                  }}
                >
                  Benefits
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#works"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('works');
                    closeMenu();
                  }}
                >
                  How it works
                </a>
              </li>
            </ul>
            <a
              className="btn join-waitlist mt-2 ms-lg-auto"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                openUserTypeModal();
                closeMenu();
              }}
            >
              Join the Waitlist
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
